import { useMemo } from "react";

import { Link } from "react-router-dom";
import { CalendarDays } from "lucide-react";
import { api } from "@/lib/api";
import { PageHeader, Panel, Table, Pill, useLoad, Loading, statusTone } from "@/components/common";

export const MeetingTable = ({ rows, testid = "meetings-table" }) => (
  <Table testid={testid} rows={rows} empty="No meetings" cols={[{ k: "date", h: "Date", r: (m) => <span className="font-mono text-xs">{m.date} {m.time}</span> },
    { k: "name", h: "Meeting", r: (m) => <Link to={`/meetings/${m.id}`} className="font-medium text-indigo-700 hover:underline" data-testid={`meeting-link-${m.id}`}>{m.name}</Link> },
    { k: "project_code", h: "Scope", r: (m) => m.project_code || <Pill tone="indigo">Portfolio</Pill> }, { k: "status", h: "Status", r: (m) => <Pill tone={statusTone(m.status)}>{m.status}</Pill> }]} />
);

export default function Meetings() {
  const { data, error } = useLoad(() => api.get("/meetings").then((r) => r.data));
  const today = new Date().toISOString().slice(0, 10);
  const [upcoming, past] = useMemo(() => [(data || []).filter((m) => m.date >= today), (data || []).filter((m) => m.date < today).reverse()], [data, today]);
  if (!data) return <Loading error={error} />;
  return (
    <>
      <PageHeader overline="Operating rhythm" title={<span className="flex items-center gap-3"><CalendarDays className="h-7 w-7 text-indigo-600" />Meetings & actions</span>}
        subtitle="Standing series are created automatically when a project passes G0. Agendas build themselves from live data." />
      <Panel title="Upcoming" testid="upcoming-meetings"><MeetingTable rows={upcoming} testid="upcoming-meetings-table" /></Panel>
      <Panel title="Past" testid="past-meetings"><MeetingTable rows={past} testid="past-meetings-table" /></Panel>
    </>
  );
}
